import { render, staticRenderFns } from "./BugReportDialog.vue?vue&type=template&id=2d7dc56c&"
import script from "./BugReportDialog.vue?vue&type=script&lang=js&"
export * from "./BugReportDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports